import { render } from "./TravelDetails.vue?vue&type=template&id=5d5ee626&scoped=true"
import script from "./TravelDetails.vue?vue&type=script&lang=js"
export * from "./TravelDetails.vue?vue&type=script&lang=js"

import "./TravelDetails.vue?vue&type=style&index=0&id=5d5ee626&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5ee626"]])

export default __exports__